module.exports = __webpack_public_path__ + "static/climate_card_img1@2x-78cc49b5b68cc750ae943d751a5f8e2e.jpg";